export const ADD_AREA = 'add area';
export const DELETE_ALL_INPUTS_CONFIRMATION = 'delete all inputs confirmation';
export const ESTIMATE_YOUR_PROJECT = 'How much for your project?';
export const LANDING = 'landing';
export const VINYL_SHEET_POPOVER_MESSAGE = 'Most vinyl sheet rolls come in a standard 12-foot width which is enough'
+ ' to cover a room that is 11.5 ft. wide or smaller. Rooms wider than 11.5 ft. will require a seam so you may want '
+ 'to call a professional installer.';
export const POD_IMAGE_SIZE = '150';